<template>
  <CModal
    color="dark"
    :show.sync="reviewModal"
    :closeOnBackdrop="false"
    size="lg"
    :addContentClasses="[]"
  >
    <template v-slot:header>
      <div><h5>Welcome to the SuperForm Dealer Portal, </h5></div>
    </template>
    <div v-if="document && !saved">
      <video-preview :document="document" :autoload="true" :cache="true"></video-preview>
<!--      <hr>-->
    </div>
<!--    <h5>Review your account before continuing...</h5>-->
<!--    <br />-->
<!--    <customer-contact-form-->
<!--      :customer_contact_id="customer_contact_id"-->
<!--      @onContactChange="v => contact = v"-->
<!--      @onUserChange="v => user = v"-->
<!--    ></customer-contact-form>-->
    <template v-slot:footer>
<!--      <c-button v-if="!saving" class="btn-sf btn-square" @click="save">Save</c-button>-->
<!--      <c-button v-if="saving" color="dark" disabled><i class="fal fa-spin fa-spinner"></i></c-button>-->
      <c-button class="btn-sf btn-square" @click="closeModal">Review Your Contact Details</c-button>
    </template>
  </CModal>
</template>

<script>
import CustomerContactForm from "../components/customers/contacts/CustomerContactForm";
import Contact from "../models/Contact";
import User from "../models/User";
import ToastNotifications from "../components/shared/mixins/ToastNotifications";
import {AUTH_SET_USER_LAST_UPDATE, AUTH_SET_WELCOME_WATCHED} from "../store/mutation-types";
import moment from "moment";
import CustomerContact from "../models/CustomerContact";
import VideoPreview from "../components/documents/VideoPreview";
import Document from "../models/Document";
export default {
  name: 'TheReview',
  components: {VideoPreview, CustomerContactForm},
  mixins: [ToastNotifications],
  data() {
    return {
      customer_contact_id: this.$store.getters.getAuthCustomerContactID,
      reviewModal: this.$store.getters.isUserNew && !this.$store.getters.hasWatchedWelcomeVideo,
      contact: null,
      user: null,
      saving: false,
      saved: false,
      document: null
    };
  },
  methods: {
    closeModal: function() {
      //reviewModal = false; this.$router.push('/account');
      this.$store.commit(AUTH_SET_WELCOME_WATCHED, true);
      this.reviewModal = false;
      this.document = null;
    },
    save: function() {
      this.saving = true;
      let p = [];
      if(this.contact) {
        let contact = JSON.parse(JSON.stringify(this.contact));
        let filtered = {};
        let fields = [
          {key: 'first_name', label: 'First Name'},
          {key: 'last_name', label: 'Last Name'},
          //{key: 'type', label: 'Type'},
          {key: 'phone', label: 'Phone'},
          {key: 'email', label: 'Email'}
        ];
        let missing = [];
        fields.forEach((temp) => {
          if(!contact[temp.key]) {
            missing.push(temp.label);
          } else {
            filtered[temp.key] = contact[temp.key];
          }
        });
        if(missing.length) {
          this.quickWarningToast('Missing Required Fields', 'You need to fill out: ' + missing.join(', '));
          this.saving = false;
          return false;
        } else {
          p.push(Contact.api().update(this.contact.id, filtered));
        }
      }
      if(this.user) {
        let user = JSON.parse(JSON.stringify(this.user));
        let filtered = {};
        let fields = [{key: 'notification_preference', label: 'Notification Preference'}];
        let missing = [];
        fields.forEach((temp) => {
          if(!user[temp.key]) {
            missing.push(temp.label);
          } else {
            filtered[temp.key] = user[temp.key];
          }
        });
        if(missing.length) {
          this.quickWarningToast('Missing Required Fields', 'You need to fill out: ' + missing.join(', '));
          this.saving = false;
          return false;
        } else {
          p.push(User.api().update(this.user.id, filtered));
        }
      }
      Promise.all(p).then(() => {
        CustomerContact.api().export(this.customer_contact_id);
        this.$store.commit(AUTH_SET_USER_LAST_UPDATE, moment().format());
        this.reviewModal = this.$store.getters.isUserOutdated;
        this.saving = false;
        this.saved = true;
        this.$router.push('/account');
      });
    },
  },
  mounted() {
    if(this.reviewModal) {
      Document.api().fetch({document_folder_id: Document.getHowToFolderId, limit: 1}).then(() => {
        this.document = Document.query().where('document_folder_id', Document.getHowToFolderId).first();
      });
    }
  }
}
</script>
